module.exports = __webpack_public_path__ + "static/media/security.1cea9d50.png";